<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h2>Kampanya Güncelle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Kampanya Başlık</h4>
          <v-text-field
            v-model="campaignData.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Mobil Başlık</h4>
          <v-text-field
            v-model="campaignData.shortDescription"
            maxlength="255"
            counter="255"
            :rules="shortDescriptionRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div class="tooltip-container">
            <h4>Son Kullanım Tarihi</h4>
            <v-tooltip
              v-if="tooltipMessage.message"
              bottom
              v-model="showTooltip"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :style="{ color: tooltipMessage.color }"
                  v-on="on"
                  @mouseenter="showTooltip = true"
                  @mouseleave="showTooltip = false"
                >
                  {{ tooltipMessage.icon }}
                </v-icon>
              </template>
              <span>{{ tooltipMessage.message }}</span>
            </v-tooltip>
          </div>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="campaignData.endDate"
                label="Son Kullanım Tarihi"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="campaignData.endDate"
              :min="new Date().toISOString().substring(0, 10)"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="3">
          <h4>Kampanya tipi</h4>
          <v-select
            v-model="campaignData.type"
            :items="campaignTypeList"
            label="Kampanya tipi"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            :rules="campaignTypeRules"
            @change="campaignTypeChange"
            :disabled="this.codeCreated"
            required
          ></v-select>
        </v-col>
        <v-col v-if="campaignData.type !== 'General'" cols="12" md="4">
          <h4>İndirim Tutarı (TL)</h4>
          <v-text-field
            v-model="campaignData.discount"
            type="number"
            :disabled="this.codeCreated"
            min="1"
            max="25000"
            :rules="campaignData.type === 'General' ? noRule : discountRules"
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="campaignData.type !== 'General'" cols="12" md="4" sm="3">
          <h4>
            Geçerlilik Süresi / Aylık tekrar adeti
            <v-icon
              style="font-size: 17px;"
              v-if="!alert"
              color="#4d48f9"
              @click="alert = !alert"
            >
              info
            </v-icon>

            <v-alert
              v-model="alert"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Sadece aylık üyelikler için geçerlidir
            </v-alert>
          </h4>
          <v-select
            v-model="campaignData.usageCount"
            :items="usageCountLimitOptions"
            :disabled="this.codeCreated"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row
        v-if="
          campaignData.type === 'Partnership' ||
          campaignData.type === 'CouponCode'
        "
      >
        <v-col cols="12" md="4" sm="3">
          <h4>Kod tipi</h4>
          <v-select
            v-model="campaignData.codeType"
            :items="codeTypeList"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            :disabled="this.codeCreated"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <h4>
            Toplam Kod Adedi
          </h4>
          <v-text-field
            v-model="campaignData.userCount"
            name="name"
            value="value"
            type="number"
            @input="handleInput"
            :rules="
              campaignData.codeType === 'General'
                ? [
                    (v) =>
                      parseInt(v) >= 1 ||
                      'Kullanım sayısı miktarı 1`den küçük olmamalıdır.',
                    (v) =>
                      parseInt(v) >= codeUsedCount ||
                      'Lütfen girdiğin kod miktarın kontrol et. Kullanılan kod miktarından daha az bir sayıya güncelleme yapılamaz.',
                  ]
                : campaignData.codeType === 'Unique'
                ? [(v) => parseInt(v) >= 1 || 'Kod miktarı ez az 1 olmalıdır.']
                : noRule
            "
            min="1"
            required
          ></v-text-field>
        </v-col>

        <v-col v-if="campaignData.codeType === 'Unique'" cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="color: white; margin-top: 35px;"
            @click="couponAdd()"
          >
            KOD OLUŞTUR
          </v-btn>
        </v-col>
        <v-col v-if="campaignData.codeType === 'General'" cols="12" md="4">
          <h4>Kampanya Kodu</h4>
          <v-text-field
            v-model="campaignData.code"
            :disabled="this.codeCreated"
            maxlength="8"
            minlenght="6"
            counter="8"
            required
            :rules="campaignData.codeType === 'General' ? codeRules : noRule"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="3">
          <h4>Segment Tipi</h4>
          <v-select
            v-model="campaignData.segmentType"
            :items="
              allSegments.map((segment, i) => {
                return {
                  value: segment,
                  label: allSegmentTypes.find((x) => x.value == segment).label,
                }
              })
            "
            data-vv-name="select"
            item-text="label"
            item-value="value"
            :rules="segmentationTypeRules"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Paket Adı</h4>
          <v-select
            v-model="campaignData.subscriptionType"
            :items="
              allSubscriptionTypes.map((subscription) => {
                return {
                  label: subscriptionLabels[subscription],
                  value: subscription,
                }
              })
            "
            item-text="label"
            item-value="value"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="campaignData.description"
            maxlength="2000"
            rows="1"
            auto-grow
            counter="2000"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!alertLink"
              color="#4d48f9"
              @click="alertLink = true"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertLink"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Dış Link eklerken http, https protokollerinin girilmesi
              gereklidir.
              <br />
              Örneğin: http://frink.com.tr, https://frink.com.tr
            </v-alert>
          </h4>
          <v-text-field
            v-model="campaignData.link"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="3">
          <h4>Link tipi</h4>
          <v-select
            v-model="campaignData.campaignLinkType"
            :items="campaignLinkTypes"
            :disabled="campaignData.link === ''"
            item-text="name"
            item-value="value"
            label="Link Tipi"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field
            v-model="campaignData.linkText"
            :disabled="campaignData.link === ''"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <h4>
            Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Kampanyanın uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="campaignData.priority"
            type="number"
            min="0"
            required
            @input="handleInput"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <h4>Uygulama İçerisinde Göster</h4>
          <v-checkbox v-model="campaignData.shown" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Aktif/Pasif</h4>
          <v-checkbox
            v-model="campaignData.active"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Görsel
            <v-icon
              style="font-size: 17px;"
              v-if="!infoImage"
              color="#4d48f9"
              @click="infoImage = true"
            >
              info
            </v-icon>
          </h4>

          <v-alert
            v-model="infoImage"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Görsel boyutu: 1000x500
            <br />
            Format: JPG
            <br />
            Dosya boyutu: Maximum 350 KB
          </v-alert>
          <v-img
            style="cursor: pointer;"
            v-if="campaignImgUrl !== '' && campaignImgUrl !== undefined"
            :src="campaignImgUrl"
            aspect-ratio="1.7"
            @click="redirectImagePath(campaignData.img)"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            @change="previewFiles"
            v-model="imageFile"
            label="Resim değiştir"
            required
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="campaignUpdate()"
            :disabled="isButtonDisabled"
          >
            GÜNCELLE
          </v-btn>
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            style="
              text-transform: none !important;
              float: left;
              color: white;
              background-color: #438726;
            "
            @click="exportExcel()"
          >
            EXPORT
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CampaignDetail',
  data: () => ({
    alert: false,
    infoImage: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    campaignImg: undefined,
    campaignImgUrl: '',
    couponCodeCount: 1,
    codeUsedCount: 0,
    codeCreated: false,
    showToolTip: false,
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => (v && v.length <= 255) || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => (v && v.length <= 2000) || 'Maksimum 2000 karakter olmalıdır.',
    ],
    shortDescriptionRules: [
      (v) => !!v || 'Kısa açıklama alanı zorunludur.',
      (v) => (v && v.length <= 255) || 'Maksimum 255 karakter olmalıdır.',
    ],
    fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Resim gereklidir.',
      (v) => (v && v.name != null) || 'Resim gereklidir.',
    ],
    orderRules: [(v) => parseFloat(v) > -1 || "Adet 0'dan küçük olmamalıdır."],
    discountRules: [
      (v) =>
        parseFloat(v) >= 1 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
      (v) =>
        parseFloat(v) <= 25000 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
    ],
    codeRules: [
      (v) => !!v || 'Kampanya kodu alanı zorunludur.',
      (v) =>
        /^\w+$/.test(v) ||
        'Genel kod yalnızca ingilizce karakterlerden oluşmalıdır.',
      (v) => (v && v.length >= 6) || 'Genel kod 6-8 karakter olmalıdır.',
      (v) => (v && v.length <= 8) || 'Genel kod 6-8 karakter olmalıdır.',
    ],
    noRule: [],
    campaignTypeRules: [(v) => !!v || 'Kampanya tipi alanı zorunludur.'],
    usageCountLimitOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    segmentationTypeRules: [
      (v) => !!v || 'Segmentasyon tipi alanı zorunludur.',
    ],
    campaignLinkTypes: [
      {
        name: 'İç Link',
        value: 'InternalLink',
      },
      {
        name: 'Dış Link',
        value: 'ExternalLink',
      },
    ],
    menu: false,

    campaignTypeList: [
      {
        name: 'Genel Kampanya',
        value: 'General',
      },
      {
        name: 'Kupon Kodu',
        value: 'CouponCode',
      },
      {
        name: 'İş Birliği',
        value: 'Partnership',
      },
    ],
    codeTypeList: [
      {
        name: 'Genel Kod',
        value: 'General',
      },
      {
        name: 'Unique Kod',
        value: 'Unique',
      },
    ],
    errorList: [],
    dialog: false,
    imageFile: null,
    isButtonDisabled: false,
  }),
  computed: {
    ...mapGetters([
      'campaignData',
      'allSegments',
      'allSubscriptionTypes',
      'allSegmentTypes',
      'subscriptionLabels',
    ]),
    tooltipMessage() {
      const endDate = new Date(this.campaignData.endDate)
      const today = new Date()
      const oneWeekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
      if (endDate < today) {
        return {
          message: 'Bu kampanya süresi sona erdi',
          icon: 'mdi-exclamation',
          color: 'crimson',
        }
      } else if (endDate <= oneWeekFromNow) {
        return {
          message: 'Bu kampanya yakında sonlanacaktır',
          icon: 'mdi-timelapse',
          color: '#FFCD3F',
        }
      }
      return { message: '', icon: '', color: 'white' }
    },
  },
  created() {
    let campaign = {
      id: this.$route.params.id,
    }
    this.getCampaign(campaign).then((data) => {
      this.campaignImgUrl = data.img
      this.codeUsedCount = data.codeUsedCount
      this.codeCreated = data.codeCreated
      if (this.campaignData.codeType === 'Unique') {
        this.campaignData.userCount = 1
      }
      this.getSegments()
      this.getSubscriptionTypes()
    })
  },
  methods: {
    ...mapActions([
      'getCampaign',
      'updateCampaign',
      'addCoupon',
      'exportCampaignCodes',
      'getSegments',
      'getSubscriptionTypes',
    ]),
    handleInput(item) {
      if (item.includes('.'))
        this.campaignData.userCount = item.replace('.', '')
    },
    campaignTypeChange(data) {
      if (
        data !== 'General' &&
        (!!this.campaignData.codeType ||
          this.campaignData.codeType === 'NO_CODE')
      )
        this.campaignData.codeType = 'General'
    },
    routeCampaigns() {
      this.$router.push('/dashboard/campaigns')
    },
    redirectImagePath(endpoint) {
      window.location.href = endpoint
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result.split(',')[1])
        reader.onerror = (error) => reject(error)
      })
    },
    previewFiles() {
      if (this.campaignData.img === undefined) {
        this.campaignImgUrl = ''
      } else {
        const file = this.imageFile
        this.campaignImgUrl = URL.createObjectURL(file)
      }
    },
    campaignUpdate() {
      if (this.$refs.form && this.$refs.form.validate()) {
        this.snackbar = true
        if (
          this.campaignData.link !== '' &&
          this.campaignData.linkText === ''
        ) {
          alert('Link metni alanı dolu olmalıdır')
          return
        }
        this.campaignData.img = this.imageFile
        this.updateCampaign(this.campaignData)
          .then((response) => {
            if (response.processStatus === 'Success') {
              alert('Kampanya başarılı bir şekilde güncellendi.')
              this.routeCampaigns()
            } else {
              alert('Bir hata oluştu')
            }
          })
          .catch((err) => {
            alert(err)
          })
      } else {
        const x = document.getElementsByClassName('v-messages__message')
        console.log(x)
        let error = []
        for (let i = 0; i < x.length; i++) {
          error.push(x[i].innerHTML)
        }
        this.errorList = error
        this.dialog = true
      }
    },
    exportExcel() {
      const exportData = {}

      exportData.campaignId = parseInt(this.$route.params.id)
      exportData.campaignName = this.campaignData.title

      this.exportCampaignCodes(exportData)
    },
    couponAdd() {
      this.couponCodeCount = this.campaignData.userCount

      this.addCoupon({
        campaignId: parseInt(this.$route.params.id),
        couponCount: parseInt(this.couponCodeCount),
      })
        .then((response) => {
          if(response){
            alert("Kupon başarıyla oluşturuldu.")
          }
        })
        .catch((err) => {
          alert('Bir hata oluştu!')
        })
    },
  },
  watch: {
    campaignData: {
      deep: true,
      handler() {
        let fields = [
          this.campaign.title,
          this.campaign.shortDescription,
          this.campaign.endDate,
          this.campaign.type,
          this.campaign.segmentType,
          this.campaign.description,
        ]

        if (this.campaignData.type !== 'General') {
          fields.push(this.campaignData.discount, this.campaignData.usageCount)
        }

        if (this.campaignData.codeType === 'General') {
          fields.push(this.campaignData.code)
        }
        if (this.campaignData.link) {
          fields = fields.concat([
            this.campaignData.link,
            this.campaignData.campaignLinkType,
            this.campaignData.linkText,
          ])
        }

        this.isButtonDisabled = fields.some((field) => !field)
      },
    },
  },
}
</script>

<style scoped>
.tooltip-container {
  display: flex;
}

.tooltip-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}

.tooltip-icon:hover {
  color: darkred;
}
</style>
